module.exports = __webpack_public_path__ + "img/invitation-to-register-for-owner-portal-th.a53cd46.png";